export default "__VITE_ASSET__d4c3f9b5__"